import { logAndylitics, log, logAPI } from "./andyliticsApi";
import { AuthenticationContext, withAdalLogin } from '../helpers/react-adal/react-adal';


/**
 * removeProviderFromFavorites
 * 
 * @param {string} token  = current user token
 * @param {string} email = user's email
 * @returns {Promise} ResultStructure
 */
export const ConvertToken = (token, email) => {
    const url = '/api/Token/GetHealthSourceToken';
    const params = {
        method: "POST",
        body: JSON.stringify({ sEmail: email, sToken: token }),
        headers: {
            "Authorization": 'bearer ' + token,
            "Accept": "application/json",
            "Content-type": "application/json"
        },
    };
    var start = new Date();

    //debugger;
    return global.fetchAdal(url, params).then(response => {
        logAPI("Api.ConvertToken", start, url);
        if (response && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            //debugger;
            return Promise.reject(response);
        }
    }).catch(err => {
        //debugger;
        logAPI("Api.ConvertToken.Failure", start, url, err); return Promise.reject(err);
    });
};


